import Image from '@next/image'
import htmlParser from 'html-react-parser'
import { htmlModuleParserOptions } from '../TabNavi/HTMLModule/HTMLModule'
import { useState } from 'react'
import { ImageType } from 'typings/image'

export type TypicalConfigurationData = {
  headline: string
  tabs: {
    title: string
    image: ImageType
    content: string
  }[]
}
type Props = { className: string; data: TypicalConfigurationData }

export const TypicalConfiguration = ({ className, data }: Props) => {
  const [activeTab, setActiveTab] = useState(0)

  const handleSetActiveTab = (i: number) => {
    setActiveTab(i)
  }

  return (
    <div className={className}>
      <ul className="grid grid-cols-fit-200 grid-rows-1 items-stretch gap-4 bg-gray px-20 py-4">
        {data.tabs.map(({ title }, i) => (
          <li
            key={`tab-${i}`}
            className={`h-full p-2 ${activeTab === i ? 'bg-red text-white' : 'bg-white'}`}
          >
            <button onClick={() => handleSetActiveTab(i)} className="h-full w-full text-left font-bold">
              {title}
            </button>
          </li>
        ))}
      </ul>
      <div className="px-4 py-6 md:px-20 md:py-16">
        <ul>
          {data.tabs.map(({ image, content, title }, i) => (
            <li
              key={`content-${i}`}
              className={`md:inline-grid md:grid-cols-2 md:grid-rows-1 md:gap-8 ${
                activeTab === i ? '' : 'sr-only'
              }`}
            >
              <h2 className="mb-6 text-3xl font-medium text-black-light md:col-span-2">{title}</h2>
              <div className="md:relative md:after:absolute md:after:top-0 md:after:-right-4 md:after:h-full md:after:border md:after:border-gray">
                <Image src={image.url} alt={image.alt} layout="responsive" width={1} height={1} />
              </div>
              <div className="pdp-html-module">{htmlParser(content, htmlModuleParserOptions)}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
